<div class="sh-form-dual-list">
    <div class="sh-dual-list__list" [id]="id + 'left-list'" [class.-sh-disabled]="isDisabled">
        <div *ngIf="hasHeaders" class="sh-form-dual-list__list__header">{{ leftHeaderText ? leftHeaderText : " " }}</div>
        <div class="sh-form-dual-list__list__body" [class.-sh-headerless]="!hasHeaders">
            <div class="sh-input-field-with-icon">
                <input
                    #searchInput
                    type="search"
                    autocomplete="off"
                    [id]="id + 'left-search-input'"
                    [formControl]="leftSearchControl"
                    [placeholder]="i18n.leftSearchPlaceholderMsg"
                    class="sh-input-field"
                />
                <svg sh-icon class="sh-input-field-with-icon__icon" [name]="'search'" [size]="sizes.SMALL" aria-hidden="true"></svg>
            </div>

            <div class="sh-form-dual-list__list__body__content">
                <div id="sh-form-dual-list__list__body__content__info-row" *ngIf="leftLoading$ | async" class="sh-dual-table-info-row">
                    {{ i18n.leftLoadingMsg }}
                </div>

                <div id="sh-form-dual-list__list__body__content__info-row" *ngIf="leftHasError && !(leftLoading$ | async)" class="sh-dual-table-info-row">
                    {{ i18n.leftLoadingFailedMsg }}
                </div>

                <div
                    id="dual-list-right-placeholder-row"
                    *ngIf="!!i18n.leftPlaceholderMsg && (leftItems$ | async)?.length === 0"
                    class="sh-form-dual-list__list__body__content__info-row"
                >
                    {{ i18n.leftPlaceholderMsg }}
                </div>

                <ng-container *ngFor="let item of filteredLeftItems$ | async; let i = index">
                    <div
                        [class.-sh-disabled]="item.disabled"
                        [class.selected]="item.checked"
                        class="sh-form-dual-list__list__body__content__row"
                        [title]="isDisabled ? disabledMsg : item.disabled ? item.disabledInfoMsg : item.label"
                        (dblclick)="onMoveOneRight(item)"
                        (click)="onSelectLeft(item, i)"
                        (keydown.enter)="onSelectLeft(item, i)"
                    >
                        {{ item.label }}
                    </div>
                </ng-container>
            </div>
        </div>
    </div>

    <div class="sh-form-dual-list__button-column">
        <sh-action-item *ngFor="let actionItem of moveActionItems$ | async" [item]="actionItem"></sh-action-item>
    </div>

    <div class="sh-dual-list__list" [class.-sh-is-invalid]="invalid" [id]="id + '-right-list'" [class.-sh-disabled]="isDisabled">
        <div *ngIf="leftHeaderText || rightHeaderText" class="sh-form-dual-list__list__header">{{ rightHeaderText ? rightHeaderText : " " }}</div>

        <div class="sh-form-dual-list__list__body" [class.-sh-headerless]="!hasHeaders">
            <div class="sh-input-field-with-icon">
                <input
                    #searchInput
                    type="search"
                    autocomplete="off"
                    [id]="id + '-right-search-input'"
                    [formControl]="rightSearchControl"
                    [placeholder]="i18n.rightSearchPlaceholderMsg"
                    class="sh-input-field"
                />
                <svg sh-icon class="sh-input-field-with-icon__icon" [name]="'search'" [size]="sizes.SMALL" aria-hidden="true"></svg>
            </div>

            <div class="sh-form-dual-list__list__body__content">
                <div id="dual-list-right-loading-row" *ngIf="rightLoading$ | async" class="sh-form-dual-list__list__body__content__info-row">
                    {{ i18n.rightLoadingMsg }}
                </div>

                <div id="dual-list-right-error-row" *ngIf="rightHasError && !(rightLoading$ | async)" class="sh-form-dual-list__list__body__content__info-row">
                    {{ i18n.rightLoadingFailedMsg }}
                </div>

                <div
                    id="dual-list-right-placeholder-row"
                    *ngIf="!!i18n.rightPlaceholderMsg && (rightItems$ | async)?.length === 0"
                    class="sh-form-dual-list__list__body__content__info-row"
                >
                    {{ i18n.rightPlaceholderMsg }}
                </div>

                <ng-container *ngFor="let item of filteredRightItems$ | async; let i = index">
                    <div
                        [class.-sh-disabled]="item.disabled"
                        [class.selected]="item.checked"
                        [title]="isDisabled ? disabledMsg : item.disabled ? item.disabledInfoMsg : item.label"
                        class="sh-form-dual-list__list__body__content__row"
                        (click)="onSelectRight(item, i)"
                        (keydown.enter)="onSelectRight(item, i)"
                        (dblclick)="onMoveOneLeft(item)"
                    >
                        {{ item.label }}
                    </div>
                </ng-container>
            </div>
        </div>
    </div>
</div>
